<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Оплата обучения',
  }
}
</script>

<style>
@import './assets/css/style.css';

#app {
  min-height: 100vh;
}
</style>